<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxCandidateName">Candidate Name</label>
                    <input
                        id="txbxCandidateName"
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.candidateName"
                        name="candidateName"
                    />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxPosition">Position</label>
                    <input id="txbxPosition" type="text" class="form-control" [(ngModel)]="target.position" name="position" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="drugTest"
                        name="drugTest"
                        [(ngModel)]="target.drugTest"
                    />
                    <label class="form-check-label" for="drugTest">Drug test</label>
                </div>
            </div>
            <div class="col-4">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="referenceCheck"
                        name="referenceCheck"
                        [(ngModel)]="target.referenceCheck"
                    />
                    <label class="form-check-label" for="referenceCheck">Reference check</label>
                </div>
            </div>
            <div class="col-4">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="voes" name="voes" [(ngModel)]="target.voes" />
                    <label class="form-check-label" for="voes">VOE's</label>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 15px">
            <div class="col-12">
                <div class="form-group">
                    <label for="txbxSource">Source of Application</label>
                    <input
                        id="txbxSource"
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.sourceOfApplication"
                        name="sourceOfApplication"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
